<template>
  <div id='login' class="signin-bg">
    <vue-element-loading :active="isLoading" is-full-screen text="Please wait..." />
    <div class="cr-card">
      <div class="card-header">
        <div class="title"  style="text-align:center;">
            <span class="title_txt">{{ $t('sys_title') }}</span>
        </div>
      </div>
      <div class="card-body">
        <div class="info">
          <span class="info-txt">{{ $t('login') }}</span>
        </div>
        <div>
          <div>
              <input class="form-control cr-input" type="text" v-model="account" :placeholder="$t('account')" style="width: 235px;"/>
          </div>
          <div>
            <input class="form-control cr-input" type="password" v-model="password" :placeholder="$t('password')" autocomplete="current-password" style="width: 235px;"/>
          </div>
          <button type="button" class="btn btn-primary" @click="signin" style="margin-left:20px;margin-top:5px;">{{ $t('login') }}</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import md5 from 'js-md5'
export default {
  name: 'login',
  data() {
    return {
      account: '',
      password: '',
      isLoading: false,
    }
  },
  components: {
    // Loading
  },
  methods: {
    signin() {
      this.isLoading = true;
      const api = `${process.env.VUE_APP_APIPATH}/login`;
      const json = {
          account: this.account,
          password: md5(this.password)
      }
      this.$http.post(api, json).then((res) => {
        const status = res.data.Status;
        if(status === 'success'){
          if(res.data.data[0].status == '0'){
            alert("帐号已停用")
            this.isLoading = false;
            return
          }
          sessionStorage.setItem("my_info", JSON.stringify(res.data.data));
          this.$router.push('/clientlist');
        }else if(status === '0xFFF1') {
          alert(this.$t("login_error1"));
        }else if(status === '0xFFF') {
          alert(this.$t("login_error2"));
        }
        this.isLoading = false;
      })
    }

  }
}
</script>

